import useGetStringifiedDateAndHour from "@/hooks/utils/useGetStringifiedDate";
import { cn } from "@/lib/utils";

type MailDateProps = {
    sentDateTime: Date;
    className?: string;
};

const MailDate = ({ sentDateTime, className }: MailDateProps) => {
    const getStringifiedDateAndHour = useGetStringifiedDateAndHour();

    return (
        <div
            className={cn(
                "w-max text-xs font-medium text-text-caption",
                className,
            )}
            id="date"
        >
            {getStringifiedDateAndHour(sentDateTime)}
        </div>
    );
};

export default MailDate;
